import React from 'react';
import StakeInput from '../StakeInput';
import { formatBalance, formatOdds } from '../../utils/common';
import minusIcon from '../../../../../../shared/assets/images/lotto-assistant/minus-circle.svg';
import plusIcon from '../../../../../../shared/assets/images/lotto-assistant/plus-circle.svg';
import classes from './BetTicket.module.scss';

const MAX_DRAWS = 10;

const BetTicketStakeSection = ({ ticket, state, derived, actions }) => {
  const hasBalls = ticket.balls != null && ticket.balls.length > 0;
  const betsCount = hasBalls
    ? derived.singleBetsCount * state.repeatForDraws
    : state.repeatForDraws;

  return (
    <div className={classes.StakeSection}>
      <div className={classes.StakeSectionPadded}>
        <div className={classes.DrawsCounterContainer}>
          <span className={classes.Label}>NUMBER OF DRAWS</span>
          <div className={classes.DrawsCounter}>
            <button
              type="button"
              onClick={() => actions.setRepeatForDraws(Math.max(1, state.repeatForDraws - 1))}
              disabled={state.repeatForDraws <= 1}
              className={classes.CounterButton}
              aria-label="Decrease draws"
            >
              <img src={minusIcon} alt="" width={32} height={32} />
            </button>
            <span className={classes.CounterValue}>{state.repeatForDraws}</span>
            <button
              type="button"
              onClick={() => actions.setRepeatForDraws(Math.min(MAX_DRAWS, state.repeatForDraws + 1))}
              disabled={state.repeatForDraws >= MAX_DRAWS}
              className={classes.CounterButton}
              aria-label="Increase draws"
            >
              <img src={plusIcon} alt="" width={32} height={32} />
            </button>
          </div>
        </div>

        {state.repeatForDraws > 1 && (
          <label className={classes.OddsCheckbox}>
            <input
              type="checkbox"
              checked={state.acceptOddsChanges}
              onChange={(e) => actions.setAcceptOddsChanges(e.target.checked)}
            />
            <span>Accept odds changes</span>
          </label>
        )}

        <div className={classes.StakeOddsRow}>
          <StakeInput
            stakeInput={state.stakeInput}
            onInputChange={actions.handleStakeChange}
            onBlur={actions.stopStakeEdit}
          />
          <div className={classes.OddsGroup}>
            <span className={classes.Label}>ODDS</span>
            <span className={classes.OddsValue}>{formatOdds(ticket.outcome?.odds)}</span>
          </div>
        </div>
      </div>

      <div className={classes.SummaryBand}>
        <div className={classes.SummaryItem}>
          <span className={classes.Label}>TO PAY</span>
          <span className={classes.SummaryValue}>{formatBalance(derived.totalCost * 100, 'ZAR')}</span>
        </div>
        <div className={classes.SummaryItem}>
          <span className={classes.Label}>BETS</span>
          <span className={classes.SummaryValue}>{betsCount}</span>
        </div>
        <div className={classes.SummaryItem}>
          <span className={classes.Label}>POTENTIAL PAYOUT</span>
          <span className={classes.SummaryPayout}>
            {formatBalance(derived.potentialPayout, 'ZAR')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BetTicketStakeSection;
